import Page from 'src/apipages/oembed/rles/index';

export default Page;
